module.exports = __webpack_public_path__ + "img/pd_C3.5.2 (_Product Drawing_).da3a52fa.png";